(function () {
  // NEYL — Product card quick-add behavior.
  //
  // The theme's stock click handler treats a card with data-quantity-in-cart > 0
  // as "show the quantity widget", not "add another". We're hiding that widget,
  // so a second click wouldn't do anything. To make every click reliably add
  // one of the displayed variant, we intercept the click in the capture phase,
  // call /cart/add.js ourselves, then re-dispatch the theme's cart:item-added
  // event so the cart drawer / mini-cart / count badge update normally.
  //
  // Multi-variant products are still handed off to the theme so the visitor
  // gets the proper variant picker / quick-add modal.

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.product-item .product-item__quick-add');
    if (!btn) return;
    var wrapper = btn.closest('.product-item__quick-add-wrapper');
    if (!wrapper) return;

    // Multi-variant products: let the theme handle (variant picker / modal).
    if (wrapper.getAttribute('data-has-variants') === 'true') return;

    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    // Take over the click before any theme handler can run.
    e.preventDefault();
    e.stopImmediatePropagation();

    btn.classList.add('is-loading');
    var failsafe = setTimeout(function () {
      btn.classList.remove('is-loading');
    }, 6000);

    var addUrl = (window.Shopify && Shopify.routes && Shopify.routes.root)
      ? (Shopify.routes.root + 'cart/add.js').replace(/\/+/g, '/')
      : '/cart/add.js';

    fetch(addUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (res) {
        return res.json().then(function (data) { return { ok: res.ok, data: data }; });
      })
      .then(function (result) {
        clearTimeout(failsafe);
        btn.classList.remove('is-loading');
        if (!result.ok) {
          console.warn('[NEYL quick-add] cart/add.js failed:', result.data);
          return;
        }
        // Reset the wrapper state so the next click is treated as a fresh add
        // even if the theme has already toggled .active onto it.
        wrapper.classList.remove('active', 'pending-collapse');
        // The theme listens for 'apps:product-added-to-cart' and reacts by
        // calling /cart.js to refresh local data, updating the header count
        // badge, refreshing the quick-cart drawer contents, and opening the
        // drawer. Dispatching this is the proper "outside-in" hook for any
        // custom add-to-cart flow.
        document.dispatchEvent(new CustomEvent('apps:product-added-to-cart', {
          bubbles: true,
          detail: { item: result.data, source: 'neyl-card-quick-add' }
        }));
      })
      .catch(function (err) {
        clearTimeout(failsafe);
        btn.classList.remove('is-loading');
        console.warn('[NEYL quick-add] error:', err);
      });
  }, true); // capture phase — runs before theme handlers attached lower in the tree
})();
